import './common'
import axios from 'axios'

export default {
    getActivities: (params) => axios.get('/activities', { params }),
    getPaginatedActivities: (params) => axios.get('/activities-paginated', { params }),
    getPeriodicActivities: (params) => axios.get('/periodic/activities', { params }),
    getActivity: (id) => axios.get(`/activities/${id}`),
    postActivity: (data) => axios.post('/activities', data),
    putActivity: (activityUUID, data) => axios.put(`/activities/${activityUUID}`, data),

    putProductsOnBookingSlotByActivity: (id, params) => axios.put(`/activities/${id}/booking-slot/add`, params),
    deleteProductsOnBookingSlotByActivity: (id, params) => axios.put(`/activities/${id}/booking-slot/deleted`, params),

    getActivitiesFamilies: (params) => axios.get('/activities-families', { params }),
    postActivityFamily: (params) => axios.post('/activities-families', params),
    putActivityFamily: (familyUUID, params) => axios.put(`/activities-families/form/${familyUUID}`, params),
    updatePositionFamilies: (params) => axios.put('/activities-families/position', params),
    deleteActivitiesFamilies: (id) => axios.delete(`/activities-families/${id}`),

    getLevels: (params) => axios.get('/levels', { params })
}
